export interface GetTipsReq {
  type: string;
}
